export const API_URL = process.env.REACT_APP_API_URL;
export const GITHUB_URL = process.env.REACT_APP_COSAP_GITHUB_URL;
